export default class ActionHandler {
    pastActions = [];
    futureActions = [];
    currentAction = null;

    current(action) {
        if (this.currentAction) {
            this.currentAction.finish();
        }
        this.currentAction = action;
    }

    finish() {
        if (this.currentAction) {
            this.pastActions.push(this.currentAction);
            this.futureActions = [];
            this.currentAction = null;
        }
    }

    undo() {
        if (this.pastActions.length > 0) {
            const action = this.pastActions.pop();
            this.futureActions.push(action);
            action.undo();
        }
    }

    redo() {
        if (this.futureActions.length > 0) {
            const action = this.futureActions.pop();
            this.pastActions.push(action);
            action.redo();
        }
    }
}
